// Komponente zum Anzeigen einer (Sub-)Kategorie im FilterMenu

import ArrowUp from "../common/ArrowUp";

function FilterCategory({ id, name, icon, color, count, checked, onChange, showToggle = false, isOpen = false, onToggle}) {
  
  return (
    <div className="FilterCategory" role="group" aria-labelledby={`filter-${id}`}>
      <div className="FilterCategory-row">

        {/* Icon/color, (sub)category name, and count */}
        <div className="FilterCategory-left">
          {icon ? (
            <span className="FilterCategory-icon subcat" aria-hidden="true">
              {icon}
            </span>
          ) : color ? (
            <span
              className="FilterCategory-icon category"
              aria-hidden="true"
              style={{ backgroundColor: color }}
            />
          ) : (
            <span className="FilterCategory-icon placeholder" aria-hidden="true">
              •
            </span>
          )}

          <label id={`filter-${id}`} className="FilterCategory-label" htmlFor={`chk-${id}`}>
            <span className={`FilterCategory-title ${icon ? 'subcat-title' : 'category-title'}`}>{name}</span>
            <span className="FilterCategory-count" aria-hidden="true">{count}</span>
          </label>
        </div>

        {/* Show/hide button and checkbox */}
        <div className="FilterCategory-controls">
          {showToggle && (
            <button
              className={`FilterCategory-toggle ${isOpen ? 'open' : ''}`}
              onClick={() => onToggle(!isOpen)}
              aria-expanded={isOpen}
              aria-label={`${isOpen ? 'Unterkategorien einklappen' : 'Unterkategorien ausklappen'}`}
            >
              <ArrowUp />
            </button>
          )}

          <div className="FilterCategory-checkboxWrapper">
            <input
              id={`chk-${id}`}
              type="checkbox"
              checked={!!checked}
              onChange={(e) => onChange(e.target.checked)}
              className="FilterCategory-nativeCheckbox"
            />
            <span className="FilterCategory-checkbox" aria-hidden="true">
              {checked && <span className="FilterCategory-checkmark">✔</span>}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterCategory;